module.exports = __webpack_public_path__ + "img/upload-item-loader.eb34adef.gif";